<template>
  <div>
    <div class="card-menu-item">
      <v-expansion-panel expand :value="panel">
        <v-expansion-panel-content :lazy="true">
          <template class="" v-slot:header >
            <div class="menu-item-title handel-menu-items handel-inner-menu-items" >
              {{item.title}}
            </div>
          </template>
          <div class="pb-3">
            <div class="d-block">
              <label for="">title</label>
              <v-text-field
                v-model="item.title"
                outline
              ></v-text-field>
            </div>

            <div class="d-block" v-if="level === 1">
              <label for="">type</label>
              <v-select
                v-model="item.type"
                @change="addNested"
                :items="['postback', 'nested']"
                outline
              ></v-select>
            </div>

            <div class="d-block" v-if="item.type === 'postback'">
              <label for="">Block</label>
              <v-autocomplete
                v-model="item.payload"
                :items="blockList"
                item-value="redirectName"
                item-text="name"
                outline
              ></v-autocomplete>
            </div>

            <div class="ml-0 lighten-2" >
              <draggable v-model="item.call_to_actions" group="subMenu" @start="drag=true" @end="drag=false" handle=".handel-inner-menu-items">
                <div v-for="(item,index) in item.call_to_actions" class="inner-menu-item mb-3">
                  <menu-item :item="item" :block-list="blockList" :level="2"></menu-item>
                  <div class="inner-menu-item-actions">
                    <v-btn
                      @click="deleteItem(index)"
                      fab small color=""
                      class=""
                    ><v-icon  color="red">delete_outline</v-icon></v-btn>
                    <v-btn  class="handel-inner-menu-items" fab small color=""><v-icon color="#666">height</v-icon></v-btn>
                  </div>
                </div>
              </draggable>
              <v-btn
                large round flat
                class="primary--text mt-3"
                @click="pushNested"
                width="600"
                v-if="item.type === 'nested'"
                block
              >
                <v-icon>add_circle_outline</v-icon>
                Add Sub Item
              </v-btn>
            </div>

          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </div>



  </div>

</template>

<script>
  import draggable from 'vuedraggable'
  import common from "../../../../utils/common"
  export default {
    name: "menuItem",
    components: {
      draggable
    },
    props: {
      item: {
        type: Object,
        default: ()=> {
          return {}
        }
      },
      blockList: {
        type: Array,
        default: () => {
          return []
        }
      },
      level: {
        type: Number,
        default: ()=> {
          return 1
        }
      }
    },
    data() {
      return {
        valid: true,
        panel: 1,
        common,
      }
    },
    mounted() {

    },
    methods: {
      addSubItem () {
        this.item.call_to_actions.push({
          type: 'postback',
          title: '',
          payload: ''
        })
      },
      addNested() {
        if (this.item.type === 'nested') {
          this.item.call_to_actions = [{
            type: 'postback',
            title: 'Sub item name',
            payload: ''
          }]
        }
      },
      pushNested () {
        this.item.call_to_actions.push({
          type: 'postback',
          title: 'Sub item name',
          payload: ''
        })
        this.$forceUpdate();
      },
      deleteItem(index) {
        this.item.call_to_actions.splice(index,1)
        this.$forceUpdate();
      }
    },
    computed: {

    },
    watch: {

    }
  }
</script>

<style lang="scss">
  .card-menu-item {
    padding: 5px 20px;
    margin-top: 15px;
    border-radius: 10px;
    overflow: hidden;
    background: white;
    .v-expansion-panel .v-expansion-panel__header {
      padding: 0;
    }
  }




  .inner-menu-item  {
    position: relative;
    border: 1px solid #eee;
    margin: 0 20px;
    border-radius: $standard-border-radius;
    .card-menu-item {
      margin-top: 0;
    }
    .inner-menu-item-actions{
      position: absolute;
      top: 0;
      left: 100%;
      display: none;
      .v-btn {
        display: block;
        width: 22px;
        height: 22px;
      }
    }
    &:hover .inner-menu-item-actions {
      display: block;
    }
  }
</style>
